import * as enums from '../../shared/enums.json';
import * as constance from '../../shared/constance.json';
export const Enums = enums;
export const Constance = constance;
